var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEstate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9008 3.14975H26.8508V3.19975V7.54785L20.5361 1.2332L20.5008 1.19784L20.4654 1.2332L1.4998 20.1988L1.46445 20.2342L1.4998 20.2695L2.631 21.4007L2.66636 21.4361L2.70171 21.4007L3.65076 20.4517V39.1998V39.2498H3.70076H37.3008H37.3508V39.1998V20.4517L38.2998 21.4007L38.3352 21.4361L38.3705 21.4007L39.5017 20.2695L39.5371 20.2342L39.5017 20.1988L34.1508 14.8478V3.19975V3.14975H34.1008H26.9008ZM35.6508 18.7517V37.5498H26.1508V23.1998V23.1498H26.1008H14.9008H14.8508V23.1998V37.5498H5.35076V18.7517L20.5008 3.60166L35.6508 18.7517ZM28.5508 4.84975H32.4508V13.1478L28.5508 9.24784V4.84975ZM16.5508 37.5498V24.8498H24.4508V37.5498H16.5508Z",
    fill: "#013F60",
    stroke: "#013F60",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstate);
export default __webpack_public_path__ + "static/media/estate.c5a7a5705793fe290d1d7275d8b74799.svg";
export { ForwardRef as ReactComponent };